// extracted by mini-css-extract-plugin
module.exports = {"menuTab":"MenuTab_menuTab__1sB3A","selectedTab":"MenuTab_selectedTab__3LKpO MenuTab_menuTab__1sB3A"};